import my from './app/mm.json';

export default {
  ...my,
};
